import ars from "../assets/img/ars.png";
import avl from "../assets/img/avl.png";
import bou from "../assets/img/bou.png";
import bre from "../assets/img/bre.png";
import bha from "../assets/img/bha.png";
import bur from "../assets/img/bur.png";
import eve from "../assets/img/eve.png";
import ful from "../assets/img/ful.png";
import liv from "../assets/img/liv.png";
import lut from "../assets/img/lut.png";
import not from "../assets/img/not.png";
import shu from "../assets/img/shu.png";
import tot from "../assets/img/tot.png";
import wol from "../assets/img/wol.png";
import che from "../assets/img/che.png";
import mci from "../assets/img/mci.png";
import mun from "../assets/img/mun.png";
import newcastle from "../assets/img/new.png";
import cry from "../assets/img/cry.png";
import whu from "../assets/img/whu.png";

export const cardsImage = [
    { src: ars, matched: false },
    { src: tot, matched: false },
    { src: wol, matched: false },
    { src: che, matched: false },
    { src: mci, matched: false },
    { src: mun, matched: false },
    { src: newcastle, matched: false },
    { src: cry, matched: false },
    { src: avl, matched: false },
    { src: whu, matched: false },
    { src: bou, matched: false },
    { src: bre, matched: false },
    { src: bha, matched: false },
    { src: bur, matched: false },
    { src: eve, matched: false },
    { src: ful, matched: false },
    { src: liv, matched: false },
    { src: lut, matched: false },
    { src: not, matched: false },
    { src: shu, matched: false },
]